import { ArrowLeftRight, FolderKanban, Trash2 } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { t } from '@/i18n';

interface BulkActionsBarProps {
  count: number;
  updating: boolean;
  canAssign: boolean;
  /** Hidden when the company has no projects (or the user can't list them). */
  canAssignProject: boolean;
  canDelete: boolean;
  onAddTags: () => void;
  onMarkPaid: () => void;
  onMarkUnpaid: () => void;
  onMarkExported: () => void;
  onAssign: () => void;
  onAssignProject: () => void;
  onDelete: () => void;
}

export function BulkActionsBar({
  count,
  updating,
  canAssign,
  canAssignProject,
  canDelete,
  onAddTags,
  onMarkPaid,
  onMarkUnpaid,
  onMarkExported,
  onAssign,
  onAssignProject,
  onDelete,
}: BulkActionsBarProps) {
  return (
    <div className="bg-primary/5 border-primary/20 flex flex-wrap items-center gap-2 rounded-lg border px-3 py-2">
      <span className="text-sm font-medium">
        {t('invoices.bulk.selected', { count })}
      </span>
      <Button variant="outline" size="sm" disabled={updating} onClick={onAddTags}>
        {t('invoices.bulk.addTags')}
      </Button>
      <Button variant="outline" size="sm" disabled={updating} onClick={onMarkPaid}>
        {t('invoices.bulk.markAsPaid')}
      </Button>
      <Button variant="outline" size="sm" disabled={updating} onClick={onMarkUnpaid}>
        {t('invoices.bulk.markAsUnpaid')}
      </Button>
      <Button variant="outline" size="sm" disabled={updating} onClick={onMarkExported}>
        {t('invoices.bulk.markAsExported')}
      </Button>
      {canAssignProject && (
        <Button variant="outline" size="sm" disabled={updating} onClick={onAssignProject}>
          <FolderKanban className="size-4" />
          {t('invoices.bulk.assignToProject')}
        </Button>
      )}
      {canAssign && (
        <Button variant="outline" size="sm" disabled={updating} onClick={onAssign}>
          <ArrowLeftRight className="size-4" />
          {t('invoices.bulk.assignToCompany')}
        </Button>
      )}
      {canDelete && (
        <Button
          variant="outline"
          size="sm"
          disabled={updating}
          className="text-destructive hover:text-destructive"
          onClick={onDelete}
        >
          <Trash2 className="size-4" />
          {t('invoices.bulk.delete')}
        </Button>
      )}
    </div>
  );
}
